import { type CSSResult, unsafeCSS } from 'lit';

import toArray from '@loadsmart/miranda-toolset/dist/to-array';

export type TransitionConfig = {
	delay?: string;
	duration?: string;
	property?: string;
	/**
	 * Timing function:
	 */
	easing?: string;
};

/** @type {TransitionConfig} */
const DEFAULT_TRANSITION_CONFIG: TransitionConfig = {
	property: 'all',
	delay: '0s',
	duration: '0.35s',
	easing: 'ease-in-out',
};

/**
 * @param {TransitionConfig} config
 */
function toTransition(config: TransitionConfig): CSSResult {
	const safeConfig = { ...DEFAULT_TRANSITION_CONFIG, ...config };

	// property name | duration | easing function | delay
	return unsafeCSS(
		`${safeConfig.property} ${safeConfig.duration} ${safeConfig.easing} ${safeConfig.delay}`,
	);
}

/**
 * Convert a transition config to its CSS equivalent.
 * @param {TransitionConfig | TransitionConfig[]} configs
 */
function transition(configs: TransitionConfig | TransitionConfig[]): CSSResult {
	const transitionStyle = toArray(configs)
		.map((config) => toTransition(config))
		.join(', ');

	return unsafeCSS(`
		transition: ${transitionStyle}
	`);
}

export default transition;
